import { render, staticRenderFns } from "./GeneralTimeStreamax.vue?vue&type=template&id=20cb3dbe&scoped=true&"
import script from "./GeneralTimeStreamax.vue?vue&type=script&lang=ts&"
export * from "./GeneralTimeStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralTimeStreamax.vue?vue&type=style&index=0&id=20cb3dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cb3dbe",
  null
  
)

export default component.exports